import {
  Component,
  computed,
  inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { IconsModule } from '@boldpenguin/emperor-icons';
import {
  EmperorButtonModule,
  EmperorSpinnerModule,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matCloseOutline } from '@ng-icons/material-icons/outline';
import { SubmissionLinkUploadService } from 'src/app/features/quotes/components/document-upload-submission-link-dialog/submission-link-upload.service';
import {
  ISmartUploadProcess,
  SmartUploadProcessStatus,
} from 'src/app/features/quotes/components/document-upload-submission-link-dialog/submission-lint-upload.models';

@Component({
  selector: 'app-in-progress-panel',
  templateUrl: './in-progress-panel.component.html',
  styleUrls: ['./in-progress-panel.component.scss'],
  imports: [
    MatExpansionModule,
    MatIconModule,
    EmperorSpinnerModule,
    EmperorButtonModule,
    IconsModule,
    NgIcon,
  ],
  providers: [provideIcons({ matCloseOutline })],
})
export class InProgressPanelComponent {
  isExpanded: WritableSignal<boolean> = signal(true);
  private _submissionLinkUploadService = inject(SubmissionLinkUploadService);
  private _router = inject(Router);
  readonly smartProcesses =
    this._submissionLinkUploadService.smartUploadProcesses;
  readonly incompleteProcessLength = computed(() => {
    const processes = this.smartProcesses();
    return processes.filter(
      (process) =>
        process.status !== SmartUploadProcessStatus.Completed &&
        process.status !== SmartUploadProcessStatus.Failed,
    ).length;
  });
  readonly EmperorUIButtonTypes = EmperorUIButtonTypes;
  readonly SmartUploadProcessStatus = SmartUploadProcessStatus;

  removeProcess(uploadId: string) {
    this._submissionLinkUploadService.smartUploadProcesses.update((processes) =>
      processes.filter((process) => process.upload_id !== uploadId),
    );
  }

  navigateToAppForm(process: ISmartUploadProcess) {
    if (!process.application_id) return;
    this._router.navigate(['/quotes/form/', process.application_id]);
    this.removeProcess(process.upload_id);
  }
}
